const VERSION_CALDENOIL_HARDCODED_YPF = { versionWebHost: "5.25.2.0", versionCaldenOil: "5.25.5.0" };
const getVersionCaldenOil = async () => {
  return VERSION_CALDENOIL_HARDCODED_YPF;
};

const version = {
  getVersionCaldenOil,
};

export default version;
